import { ensureTab, appendRow } from '../lib/googleSheets';

const TAB_NAME = 'BrainResults';
const HEADERS = [
  'id', 
  'user_name', 
  'user_email', 
  'target_name', 
  'quiz_type', 
  'cerebrumRoot', 
  'cerebrumLeaf', 
  'cerebrumFlower', 
  'limbicSystem', 
  'brainstem', 
  'total_average',
  'created_at'
];

export async function saveResultToSheets(data) {
  try {
    await ensureTab(TAB_NAME, HEADERS);
    
    const scores = data.scores;
    const avg = Object.values(scores).reduce((a, b) => a + b, 0) / Object.values(scores).length;

    const row = [
      crypto.randomUUID(),
      data.userInfo.name,
      data.userInfo.email,
      data.userInfo.targetName || 'Self',
      data.quizType,
      scores.cerebrumRoot.toFixed(2),
      scores.cerebrumLeaf.toFixed(2),
      scores.cerebrumFlower.toFixed(2),
      scores.limbicSystem.toFixed(2),
      scores.brainstem.toFixed(2),
      avg.toFixed(2),
      new Date().toISOString()
    ];

    await appendRow(`${TAB_NAME}!A:L`, row);
    return true;
  } catch (error) {
    console.error('Failed to save to Google Sheets:', error);
    return false;
  }
}